import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    locale: sessionStorage.getItem("locale") || "zh-TW",
    type: sessionStorage.getItem("type") || 3,
    AcceptLanguage: sessionStorage.getItem("AcceptLanguage") || 2, // 1表示国外 2表示繁体 3表示国内
    SourceType: sessionStorage.getItem("SourceType") || 0, //0:国内 1:海外
  },
  mutations: {
    setLang(state, locale) {
      state.locale = locale;
      sessionStorage.setItem("locale", locale);
    },
    checkCountry(state, type) {
      state.type = type;
      sessionStorage.setItem("type", type);
    },
    AcceptLanguage(state, language) {
      state.AcceptLanguage = language;
      sessionStorage.setItem("AcceptLanguage", language);
    },
    SourceType(state, SourceType) {
      state.SourceType = SourceType;
      sessionStorage.setItem("SourceType", SourceType);
    },
  },
  actions: {
    AcceptLanguage(context, AcceptLanguage) {
      context.commit("AcceptLanguage", AcceptLanguage);
    },
  },
});
